module.exports = __webpack_public_path__ + "static/media/hamantash2.4552921e.png";